import LZString from 'lz-string';
export default {
    name: 'Avatar',

    props: ['image', 'notifications'],

    computed: {
        currentUser() {
            const raw = localStorage.getItem('PACOUS');
            let user;

            try {
                const decompressed = LZString.decompressFromUTF16(raw);
                if (decompressed) {
                    user = JSON.parse(decompressed).user;
                } else {
                    // Fallback al formato base64 antiguo
                    user = JSON.parse(decodeURIComponent(escape(window.atob(raw)))).user;
                }
            } catch (e) {
                console.error('❌ Error al descomprimir PACOUS:', e);
                user = {}; // Fallback en caso de error
            }

            return `${user.given_name} ${user.family_name_1}`;
        }
    }
};
